import React from 'react';
import {connect} from 'react-redux';
import MarkdownLoader from './MarkdownLoader';

function ProgramDetailsTools({program_tools_page}) {
    return (
        <MarkdownLoader source={program_tools_page}/>
    );
}

function mapStateToProps(state) {
    return {
        program_tools_page: state.settings.program_tools_page || '/program_tools.html'
    }
}

export default connect(mapStateToProps)(ProgramDetailsTools);
